import { AuthenticationService } from "../../services/authentication-service/authentication.service";
import { IAuthenticationService } from "../../services/authentication-service/authentication.service.interface";

const logoutService: IAuthenticationService = new AuthenticationService();

export function useLogout() {
  return { logout: logoutService.logoutAndResetStorage.bind(logoutService) };
}
